import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        review: '='
    },
    template: `
        <div class="heading01">
            <h2 ng-if="vm.isDefaultLayout">{{ 'performanceReview.Feedback for Postimees Grupp' | translate }}</h2>
            <h2 ng-if="!vm.isDefaultLayout">{{ vm.questionsByCategory[0].name }}</h2>
        </div>
        <div class="quiz" ng-if="vm.isDefaultLayout">
            <h3 ng-if="vm.questionsByCategory" ng-repeat-start="(index, category) in vm.questionsByCategory">{{ index !== 0 ? category.name : '' }}</h3>
            <div class="question" ng-repeat-end ng-repeat="question in category.questions">
                <h4>{{ question.activeI18n.name }}</h4>
                <div class="colholder">
                    <div class="col col04 fixed">
                        <p class="desc">{{ 'performanceReview.Filled by employee' | translate }}</p>
                        <textarea
                            ng-disabled="vm.review.isReadOnly || vm.review.isManager"
                            ng-readOnly="vm.review.isReadOnly || vm.review.isManager"
                            class="form-control print-hide"
                            ng-model="vm.questionAnswers[question.activeI18n.questionId].answer"
                        ></textarea>
                        <span class="print-only">{{vm.questionAnswers[question.activeI18n.questionId].answer}}</span>
                    </div>
                    <div class="col col02 fixed">
                        <p class="desc">{{ 'performanceReview.Filled by manager' | translate }}</p>
                        <textarea
                            ng-disabled="vm.review.isReadOnly || !vm.review.isManager"
                            ng-readOnly="vm.review.isReadOnly || !vm.review.isManager"
                            class="form-control print-hide"
                            ng-model="vm.questionAnswers[question.activeI18n.questionId].comment"
                        ></textarea>
                        <span class="print-only">{{vm.questionAnswers[question.activeI18n.questionId].comment}}</span>
                    </div>
                </div>
            </div>
            <div ng-if="!vm.isDefaultLayout" class="question" ng-repeat-end ng-repeat="question in category.questions">
                <h4>{{ question.activeI18n.name }}</h4>
                <div class="question">
                    <p class="desc">{{ 'performanceReview.Filled by employee' | translate }}</p>
                    <textarea
                        ng-disabled="vm.review.isReadOnly || vm.review.isManager"
                        ng-readOnly="vm.review.isReadOnly || vm.review.isManager"
                        class="form-control print-hide"
                        ng-model="vm.questionAnswers[question.activeI18n.questionId].answer"
                    ></textarea>
                    <span class="print-only">{{vm.questionAnswers[question.activeI18n.questionId].answer}}</span>
                </div>
            </div>
        </div>
        <div class="quiz" ng-if="!vm.isDefaultLayout">
            <h3 ng-if="vm.questionsByCategory" ng-repeat-start="(index, category) in vm.questionsByCategory"></h3>
            <div class="question" ng-repeat-end ng-repeat="question in category.questions">
                <h4>{{ question.activeI18n.name }}</h4>
                <div class="question">
                    <textarea
                        ng-disabled="vm.review.isReadOnly || (vm.review.isManager && !question.question.isAnswerEditableByManager)"
                        ng-readOnly="vm.review.isReadOnly || (vm.review.isManager && !question.question.isAnswerEditableByManager)"
                        class="form-control print-hide"
                        ng-model="vm.questionAnswers[question.activeI18n.questionId].answer"
                    ></textarea>
                    <span class="print-only">{{vm.questionAnswers[question.activeI18n.questionId].answer}}</span>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($scope, $rootScope, $translate, ReviewResource, ReviewService, REVIEW_STEP_ENUM, REVIEW_LAYOUT_ENUM) {
        this.$scope = $scope;
        this.$translate = $translate;
        this.ReviewResource = ReviewResource;
        this.ReviewService = ReviewService;
        this.REVIEW_STEP_ENUM = REVIEW_STEP_ENUM;
        this.REVIEW_LAYOUT_ENUM = REVIEW_LAYOUT_ENUM;
        $scope.$on('review:save', () => this.save());
        $rootScope.$on('review:language', (event, language) => this.loadQuestions(language));
    }

    $onInit () {
        this.loadQuestions(this.$translate.use());
        this.isDefaultLayout = this.review.form.layoutType === this.REVIEW_LAYOUT_ENUM.DEFAULT;
    }

    loadQuestions (_lang) {
        this.ReviewResource.question({
            guid: this.review.guid,
            stepType: this.REVIEW_STEP_ENUM.FEEDBACK,
            _lang
        }).$promise.then(questionsByCategory => {
            this.questionsByCategory = questionsByCategory;
            this.questionAnswers = this.ReviewService.getQuestionAnswers(questionsByCategory, this.review);
        });
    }

    save () {
        this.ReviewResource.setAnswers({ guid: this.review.guid }, this.questionAnswers).$promise
            .then((storedAnswers) => {
                this.ReviewService.updateQuestionAnswers(storedAnswers, this.review);
                this.$scope.$emit('review:save:success');
            })
            .catch(() => this.$scope.$emit('review:save:error'));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/review/default/feedback/index.js